import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Button } from "../Button";
import { sizes, themes } from "../Button/constants";
import { datesArrayToDateString } from "./helpers";
import { defaultPropObject } from "../constants";
import { Customize } from "../icons";
import { ButtonBase } from "../internal/ButtonBase";
import { ClickOutside } from "../internal/ClickOutside";
import { deprecate } from "../utils/deprecate";
import Scrollbar from '../Scrollbar';
import { ActiveFilters, Filters } from './components';
import styles from './ComplexFilter.css';
var cx = classNames.bind(styles);
var deprecation = deprecate('Компонент ComplexFilter устареет начиная с версии 4.0.0, будет заменен ComplexFilterCanary.', 'ComplexFilter');
export var ComplexFilter = function ComplexFilter(_ref) {
  var filterList = _ref.filterList,
      onAccept = _ref.onAccept,
      onReset = _ref.onReset,
      onClearActiveFilter = _ref.onClearActiveFilter,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      activeFilters = _useState4[0],
      setActiveFilters = _useState4[1];

  deprecation();
  var toggleRef = useRef();

  var handleToggle = function handleToggle() {
    setIsOpen(function (prevState) {
      return !prevState;
    });
  };

  var handleCloseBody = function handleCloseBody() {
    setIsOpen(false);
  };

  var defineActiveFilter = useCallback(function () {
    var result = [];
    filterList.forEach(function (filter) {
      if (filter.type === 'date') {
        if (filter.value) {
          result.push({
            name: filter.name,
            value: datesArrayToDateString(filter.value)
          });
        }
      } else if (filter.type === 'select') {
        if (filter.value) {
          var label = filter.value.label;

          if (label) {
            result.push({
              name: filter.name,
              value: label
            });
          }
        }
      } else if (filter.value) {
        result.push({
          name: filter.name,
          value: filter.value
        });
      }
    });
    setActiveFilters(result);
  }, [filterList]);
  useEffect(function () {
    defineActiveFilter();
  }, [defineActiveFilter]);

  var handleAccept = function handleAccept() {
    defineActiveFilter();
    handleCloseBody();
    onAccept();
  };

  var handleClearActiveFilter = function handleClearActiveFilter(name) {
    var clearFilters = activeFilters.filter(function (filter) {
      return filter.name !== name;
    });
    filterList.forEach(function (filter) {
      if (filter.name === name) {
        filter.onChange(null);
      }
    });
    setActiveFilters(clearFilters);

    if (onClearActiveFilter) {
      onClearActiveFilter(name);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', classes.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('controls')
  }, /*#__PURE__*/React.createElement(Scrollbar, {
    className: cx('scrollbar')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('active-filters', classes.activeFilter)
  }, /*#__PURE__*/React.createElement(ActiveFilters, {
    activeFilters: activeFilters,
    onClear: handleClearActiveFilter
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('filter-wrapper')
  }, /*#__PURE__*/React.createElement(ButtonBase, {
    ref: toggleRef,
    onClick: handleToggle,
    className: cx(classes.filterButton)
  }, /*#__PURE__*/React.createElement(Customize, {
    color: "N300"
  })), /*#__PURE__*/React.createElement(ClickOutside, {
    ignoreRefs: [toggleRef],
    onClickOutside: handleCloseBody,
    className: cx('click-outside')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('filter-body', {
      opened: isOpen
    }, classes.filterBody)
  }, /*#__PURE__*/React.createElement(Filters, {
    filterList: filterList
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('buttons')
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onReset,
    block: true,
    theme: themes.secondary,
    size: sizes.small
  }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleAccept,
    block: true,
    theme: themes.b2c,
    size: sizes.small,
    classes: {
      root: cx('margin-button')
    }
  }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C")))))));
};
export default ComplexFilter;